import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../components/SafeIcon';

const About = () => {
  return (
    <div className="bg-white min-h-screen">
      {/* Header */}
      <div className="bg-primary py-16 text-center">
        <div className="container-custom">
          <h1 className="text-4xl font-bold text-white mb-4">Our Mission</h1>
          <p className="text-primary-light text-xl max-w-2xl mx-auto">
            To bring transparency, accountability, and safety to the moringa supplement industry through independent data and reporting.
          </p>
        </div>
      </div>

      <div className="container-custom py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Why We Exist</h2>
            <div className="prose text-gray-600 space-y-4">
              <p>
                The supplement industry is loosely regulated, and moringa products—often imported from regions with varying agricultural standards—are particularly susceptible to contamination.
              </p>
              <p>
                Heavy metals, salmonella, and adulteration with fillers are real risks. Consumers deserve to know what is in the products they consume.
              </p>
              <p>
                We aggregate data from regulatory bodies, third-party labs, and verified consumer reports to build a comprehensive safety profile for the industry.
              </p>
            </div>
            
            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-100">
                <SafeIcon icon={FiIcons.FiShield} className="text-accent text-2xl mb-2" />
                <h3 className="font-bold text-gray-900">Independent</h3>
                <p className="text-sm text-gray-500">We accept no funding from supplement manufacturers.</p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg border border-gray-100">
                <SafeIcon icon={FiIcons.FiDatabase} className="text-accent text-2xl mb-2" />
                <h3 className="font-bold text-gray-900">Data-Driven</h3>
                <p className="text-sm text-gray-500">Our reports are based on lab tests and official filings.</p>
              </div>
            </div>
          </div>
          
          <div className="bg-gray-100 rounded-2xl p-8 lg:p-12">
            <h3 className="text-xl font-bold text-gray-900 mb-6">Contact Us</h3>
            <form className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:border-primary focus:ring-1 focus:ring-primary outline-none" placeholder="Your name" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <input type="email" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:border-primary focus:ring-1 focus:ring-primary outline-none" placeholder="you@example.com" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Message / Tip</label>
                <textarea rows="4" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:border-primary focus:ring-1 focus:ring-primary outline-none" placeholder="Tell us about a safety concern..."></textarea>
              </div>
              <button className="w-full bg-primary text-white font-bold py-3 rounded-lg hover:bg-primary-light transition-colors">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;